import React, { useEffect, useRef } from 'react';
import { copyIcon, newChatIcon, rewindIcon, editIcon, regenerateIcon } from '../../assets/icons';
import styles from './MessageMenu.module.css';
import { MessageType, MessagePosition, MessageMenuProps } from '../../types/message';

const MessageMenu: React.FC<MessageMenuProps> = ({ 
  position, 
  onClose, 
  onCopy,
  onNewChat,
  onRewind,
  onEdit,
  onRegenerate,
  isLastMessage,
  isCharacterMessage,
  message,
  isRegenerating = false
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (menuRef.current && event.target instanceof Node && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  const handleCopy = (): void => {
    onCopy(message.content);
    onClose();
  };

  const handleNewChat = (): void => {
    onNewChat();
    onClose();
  };

  const handleRewind = (): void => {
    onRewind();
    onClose();
  };

  const handleEdit = (): void => {
    onEdit();
    onClose();
  };

  const handleRegenerate = (): void => {
    if (!isRegenerating) {
      onRegenerate();
      onClose();
    }
  };

  return (
    <div className={styles.menuBackdrop} onClick={onClose}>
      <div 
        className={styles.menuContainer} 
        style={{ top: position.y, left: position.x }}
        ref={menuRef}
        onClick={e => e.stopPropagation()}
      >
        <button className={styles.menuItem} onClick={handleCopy}>
          <img src={copyIcon} alt="" className={styles.menuIcon} />
          <span>Copy</span>
        </button>
        <button className={styles.menuItem} onClick={handleNewChat}>
          <img src={newChatIcon} alt="" className={styles.menuIcon} />
          <span>New chat from here</span>
        </button>
        {!isLastMessage && (
          <button className={styles.menuItem} onClick={handleRewind}>
            <img src={rewindIcon} alt="" className={styles.menuIcon} />
            <span>Rewind to here</span>
          </button>
        )}
        <button className={styles.menuItem} onClick={handleEdit}>
          <img src={editIcon} alt="" className={styles.menuIcon} />
          <span>Edit message</span>
        </button>
        {isLastMessage && isCharacterMessage && (
          <button 
            className={`${styles.menuItem} ${isRegenerating ? styles.disabled : ''}`} 
            onClick={handleRegenerate}
            disabled={isRegenerating}
          >
            <img src={regenerateIcon} alt="" className={`${styles.menuIcon} ${isRegenerating ? styles.disabled : ''}`} />
            <span>{isRegenerating ? 'Regenerating...' : 'Regenerate message'}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default MessageMenu; 